import React, { useState, useEffect, Fragment, useContext, useRef, useCallback } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Button, Modal, Spin, Statistic } from 'antd'
import NodeRSA from 'node-rsa'
import QrCode from 'qrcode.react'
import Image from 'next/image'
import { localStorage } from '@/utils'
import { paymentJaPayflow, getInitCardInfo } from '@/components/H5PC/service';
import myContext from '@/utils/createContext'

const { Countdown } = Statistic
const QrcodePay = props => {
    const lang = localStorage.getItem('locale')
    const { intl, prePayment = "" } = props
    const { urlParams, checkPolling, type, initData, isMobile, publicKey, key, token, orderStatus } = useContext(myContext) || {}
    const { formatMessage } = intl

    const [codeValid, setCodeValid] = useState(false)
    const [loading, setLoading] = useState(true)
    const [qrTtl, setQrTtl] = useState(0)
    const [qrCode, setQrCode] = useState('')

    useEffect(() => {
        if (publicKey && token && (orderStatus && orderStatus != 'PS')) { 
            fetchData(token, publicKey)
        }
    }, [publicKey, token, orderStatus])

    const fetchData = async (token, publicKey) => {
        let params = {
            terminalType: isMobile ? 'WAP' : 'WEB',
            paymentType: type,
        }
        const pubKey = new NodeRSA(publicKey, 'pkcs8-public')
        // 必须得加，要和java加密解密统一
        pubKey.setOptions({ encryptionScheme: 'pkcs1' })
        const newParams = JSON.stringify(params)
        const encrypt_data = pubKey.encrypt(newParams, 'base64')
        // 加密后的参数
        payment(token, encrypt_data)
    }

    const payment = async (token, encrypt_data) => {
        setLoading(true)
        const params = {
            encrypted: encrypt_data,
            token,
        }
        const res = await paymentJaPayflow('offline', key, params);
        if (res.code === 600001 || res.code === 600002) {
            const resNext = await getInitCardInfo('cashier', key);
            const myToken = resNext && resNext.data && resNext.data.token;
            const myPublicKey = resNext && resNext.data && resNext.data.publicKey

            fetchData(myToken, myPublicKey)
        }

        if (res && res.code === 200000) {
            if (res.data.paymentStatus === 'PF') { 
                Modal.warning({
                    width: isMobile ? '80%' : '500px',
                    centered: true,
                    content: formatMessage({ id: 'ga-checkout.error-990000'}),
                    className: isMobile ? 'h5pc-cashier-error_modal' : '',
                    okText: formatMessage({ id: 'ga-checkout.got-it' }),
                    onOk() {
                        return new Promise((resolve, reject) => {
                            setLoading(false);
                            setTimeout(resolve, 500); 
                        });
                    },
                });
            } else {
                setLoading(false)
                if (res.data.redirectUrl) {
                    setCodeValid(true)
                    // 获取二维码
                    setQrCode(res.data?.redirectUrl)

                    setQrTtl(res.data?.effectiveTime)

                    // 显示即轮询
                    checkPolling()
                }
            }
        }

        if (res.code === 200100) {
            Modal.warning({
                width: isMobile ? '80%' : '500px',
                centered: true,
                className: isMobile ? 'h5pc-cashier-error_modal' : '',
                // content: CodeMsg(990000),
                content: formatMessage({ id: 'ga-checkout.error-200100' }),
                // okText: 'Got It',
                okText: formatMessage({ id: 'ga-checkout.got-it' }),
                onOk() {
                    return new Promise((resolve, reject) => {
                        setLoading(false);
                        window.location.href = '/success?errorCode=200100'
                    });
                },
            });
        }
    }

    const onCountdownFinish = () => {
        setCodeValid(false)
        setQrTtl(0)
    }

    // 重新获取二维码
    const refreshCode = () => {
        // const methods = payMethods.filter(x => x.indexOf('_TM') > -1)
        const params = {
            terminalType: isMobile ? 'WAP' : 'WEB',
            paymentType: type,
        }
        const pubKey = new NodeRSA(publicKey, 'pkcs8-public')
        // 必须得加，要和java加密解密统一
        pubKey.setOptions({ encryptionScheme: 'pkcs1' })
        const newParams = JSON.stringify(params)
        const encrypt_data = pubKey.encrypt(newParams, 'base64')

        payment(token, encrypt_data)
    }

    const renderText = () => {
       const _html = <>
           <span style={{verticalAlign: 'super'}}>
               <FormattedMessage id={`${prePayment}.${type}.qrcode.tip`} />
           </span>
        </>
        return _html
    }

    const deadline = Date.now() + qrTtl * 1000

    return (
        <Fragment>
            <div className="qr">
                <div className="qr-code">
                    <div className="qr-code-title" style={{ textAlign: 'center',marginLeft: '0' }}>
                        {renderText()}
                    </div>
                    {loading ? (
                        <Spin size="medium"></Spin>
                    ) : (
                        <Fragment>
                            <div className="qr-code-img">
                                {codeValid ? (
                                    <div className="qr-code-img-valid">
                                        <QrCode value={qrCode} size={200} id={`${prePayment}-${type}-qrcode`} />
                                        <div className="qr-code-countdown">
                                            {
                                                lang === 'zh-CN' || lang === 'zh-TW' || lang === 'ja-JP' ?
                                                    <>
                                                        <FormattedMessage id="thai-qr.countdown-before" />
                                                        <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                        <FormattedMessage id="thai-qr.countdown-mins" />
                                                    </>
                                                    :
                                                    <>
                                                        <FormattedMessage id="thai-qr.countdown" />
                                                        <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                        <FormattedMessage id="thai-qr.countdown-mins" />
                                                    </>
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <div className="qr-code-img-invalid" onClick={refreshCode}>
                                        <Image src="/static/images/shixiao@3x.png" alt="invalid" width={240} height={228} />
                                        <div className="qr-code-img-invalid-refresh">
                                            <Image src="/static/images/shuaxin@2x.png" alt="invalid" width={41} height={28} />
                                            <br />
                                            <Button type="link">
                                                <FormattedMessage id="thai-qr.refresh" />
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Fragment>
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default injectIntl(QrcodePay)
